import { useLayoutEffect, useRef, useState } from "react";
import { textBlocks } from "@/lib/posting";
import PostingBlocks from "./PostingBlocks";

/** The start of a posting's text beside the list, in the shape of its page. Text the box cuts fades out. */
export default function PostingOpening({ description }: { description: string }) {
    const box = useRef<HTMLDivElement>(null);
    const text = useRef<HTMLDivElement>(null);
    const [cut, setCut] = useState(false);

    useLayoutEffect(() => {
        const element = box.current;
        if (!element || !text.current) return;
        const measure = () => setCut(element.scrollHeight > element.clientHeight);
        measure();
        // The text reflows as the drawer narrows and when its font arrives.
        if (typeof ResizeObserver === "undefined") return;
        const observer = new ResizeObserver(measure);
        observer.observe(text.current);
        return () => observer.disconnect();
    }, [description]);

    const blocks = textBlocks(description);
    if (blocks.length === 0) {
        return (
            <p className="m-0 text-[15px] leading-[22px] text-fg-muted">
                The posting gives no text.
            </p>
        );
    }
    return (
        <div
            ref={box}
            data-testid="posting-opening"
            className={`max-h-[300px] overflow-hidden ${
                cut ? "[mask-image:linear-gradient(to_bottom,#000_72%,transparent)]" : ""
            }`}
        >
            <div
                ref={text}
                className="flex flex-col gap-2.5 text-[15px] leading-[22px] [text-wrap:pretty] [&>[data-field]+[data-field]]:-mt-1.5"
            >
                <PostingBlocks
                    blocks={blocks}
                    Heading="h4"
                    headingClassName="m-0 mt-2 -mb-1 text-[15px] leading-[22px] font-semibold text-fg first:mt-0"
                />
            </div>
        </div>
    );
}
